// extracted by mini-css-extract-plugin
module.exports = {"list_style":"ListItemCB_list_style__EbCx_","li_style":"ListItemCB_li_style__8UsPw","sas_assignment_list_style":"ListItemCB_sas_assignment_list_style__1ToxN"};